/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * Load Reddit event listeners
 *
 * Basic info: https://redditinc.force.com/helpcenter/s/article/Install-the-Reddit-Pixel-on-your-website
 * Advanced matching: https://redditinc.force.com/helpcenter/s/article/Reddit-Pixel-Advanced-Matching
 * Event metadata: https://redditinc.force.com/helpcenter/s/article/Reddit-Pixel-Event-Metadata
 * CAPI: https://ads-api.reddit.com/docs/v3/capi-direct-integration
 * */

// Pixel load event listener
pmw.bus.on("pmw:load-pixels", () => {
	if (pmwDataLayer?.pixels?.reddit?.advertiser_id && !pmwDataLayer?.pixels?.reddit?.loaded) {
		if (pmw.consent.canPixelBeFired("marketing", "Reddit")) pmw.loadRedditPixel();
	}
});

// PageView event (Server-to-Server)
pmw.bus.on("pmw:pixel:page-view", (payload) => {

	try {
		if (pmw.canNotFireRedditEvent()) return;
		if (!pmw.shouldFireBrowserPixel(payload, "reddit")) return;

		const redditData = payload.pixels?.reddit;
		if (!redditData) return;

		// Fire browser pixel with the same conversion ID that will be sent to S2S
		rdt("track", redditData.event_name, redditData.event_data);
		pmw.console.log("Reddit Pixel: PageVisit event sent", redditData.event_data);

	} catch (e) {
		console.error(e);
	}
});

// AddToCart event (Server-to-Server)
pmw.bus.on("pmw:pixel:add-to-cart", (payload) => {

	try {
		if (pmw.canNotFireRedditEvent()) return;
		if (!pmw.shouldFireBrowserPixel(payload, "reddit")) return;

		const redditData = payload.pixels?.reddit;
		if (!redditData) return;

		rdt("track", redditData.event_name, redditData.event_data);
		pmw.console.log("Reddit Pixel: AddToCart event sent", redditData.event_data);

	} catch (e) {
		console.error(e);
	}
});

// ViewContent event (Server-to-Server)
pmw.bus.on("pmw:pixel:view-item", (payload) => {

	try {
		if (pmw.canNotFireRedditEvent()) return;
		if (!pmw.shouldFireBrowserPixel(payload, "reddit")) return;

		const redditData = payload.pixels?.reddit;
		if (!redditData) return;

		rdt("track", redditData.event_name, redditData.event_data);
		pmw.console.log("Reddit Pixel: ViewContent event sent", redditData.event_data);

	} catch (e) {
		console.error(e);
	}
});

// Search event (Server-to-Server)
pmw.bus.on("pmw:pixel:search", (payload) => {

	try {
		if (pmw.canNotFireRedditEvent()) return;
		if (!pmw.shouldFireBrowserPixel(payload, "reddit")) return;

		const redditData = payload.pixels?.reddit;
		if (!redditData) return;

		rdt("track", redditData.event_name, redditData.event_data);
		pmw.console.log("Reddit Pixel: search event sent", redditData.event_data);

	} catch (e) {
		console.error(e);
	}
});

// AddToWishlist event (Server-to-Server)
pmw.bus.on("pmw:pixel:add-to-wishlist", (payload) => {

	try {
		if (pmw.canNotFireRedditEvent()) return;
		if (!pmw.shouldFireBrowserPixel(payload, "reddit")) return;

		const redditData = payload.pixels?.reddit;
		if (!redditData) return;

		rdt("track", redditData.event_name, redditData.event_data);
		pmw.console.log("Reddit Pixel: AddToWishlist event sent", redditData.event_data);

	} catch (error) {
		console.error(error);
	}
});

// Purchase event (Server-to-Server)
pmw.bus.on("pmw:pixel:purchase", (payload) => {

	try {
		if (pmw.canNotFireRedditEvent()) return;
		if (!pmw.shouldFireBrowserPixel(payload, "reddit")) return;

		const redditData = payload.pixels?.reddit;
		if (!redditData) return;

		rdt("track", redditData.event_name, redditData.event_data);
		pmw.console.log("Reddit Pixel: Purchase event sent", redditData.event_data);

	} catch (e) {
		console.error(e);
	}
});

// Note: Purchase S2S is also handled automatically via WooCommerce order hooks on the server-side
